export default "__VITE_ASSET__HP3sB9Gb__"